import { render, staticRenderFns } from "./resetphone.vue?vue&type=template&id=4db33dfe&scoped=true&"
import script from "./resetphone.vue?vue&type=script&lang=js&"
export * from "./resetphone.vue?vue&type=script&lang=js&"
import style0 from "./resetphone.vue?vue&type=style&index=0&id=4db33dfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db33dfe",
  null
  
)

export default component.exports